import { useState, useEffect } from "react";
import { endUserAPI } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { History, Loader2 } from "lucide-react";

function fmtDate(s) {
  if (!s) return "";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("es-MX", { weekday: "short", day: "numeric", month: "short" });
}

export default function AppHistoryPage() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    endUserAPI.sessions()
      .then((res) => setSessions(res.data.sessions || []))
      .catch(() => setSessions([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-foreground">Historial</h1>
        <p className="text-sm text-muted-foreground">Tus sesiones registradas</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 text-primary animate-spin" /></div>
      ) : sessions.length === 0 ? (
        <Card className="shadow-sm">
          <CardContent className="p-8 text-center">
            <History className="w-10 h-10 mx-auto mb-3 text-muted-foreground opacity-40" />
            <p className="text-sm text-muted-foreground">Todavía no registras sesiones.</p>
          </CardContent>
        </Card>
      ) : (
        sessions.map((s) => (
          <Card key={s.id} className="shadow-sm" data-testid="app-session-row">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium capitalize">
                  {fmtDate(s.performed_at) || fmtDate(s.created_at) || "Sesión"}
                </p>
                <div className="flex gap-1.5">
                  <Badge variant="secondary" className="text-[10px]">Dolor {s.pain_level}/10</Badge>
                  {s.rpe ? <Badge variant="secondary" className="text-[10px]">RPE {s.rpe}</Badge> : null}
                </div>
              </div>
              {s.notes && <p className="text-xs text-muted-foreground mt-1.5">{s.notes}</p>}
            </CardContent>
          </Card>
        ))
      )}
    </div>
  );
}
